import {useEffect, useState} from 'react'
import {defaultAvatarUrl} from '@utils/Const'
import {
  Box,
  Center,
  Flex,
  Grid,
  GridItem,
  Icon,
  Image,
  Text,
  Tooltip,
} from '@chakra-ui/react'
import IconArrow from '@assets/svgs/arrow_bottom.svg'
import {ReactComponent as ArrowDownIcon} from '@assets/svgs/arrow_down.svg'
import {CommonColors} from '@utils/CommonStyles'
import appRequest from '@apis/app'
import IconDetail from '@assets/svgs/ic_detail.svg'
import {useLocation} from 'react-router-dom'

const BrandScore = ({message}: any) => {
  const [isExpand, setIsExpand] = useState(false)
  const [dataExpand, setData] = useState<any>()
  const {feature_name} = useLocation()?.state || {}

  const onClickExpand = async () => {
    let res = await appRequest.getScoreBrand(message?.message?.score_id)
    setData(res?.data?.data)
    setIsExpand(true)
  }

  useEffect(() => {
    if (feature_name !== 'LESSON_PART_ONE') return
    const element = document.querySelector(
      '.brand-score-container',
    ) as HTMLElement
    if (element) {
      element.style.display = 'none'
    }
  }, [message])

  return (
    <div className={`chat-message brand-score`}>
      <img src={defaultAvatarUrl} alt="Avatar" className="avatar" />
      <Box
        sx={styles.container}
        padding={{base: '10px', md: '24px'}}
        ml={{base: '8px', md: '16px'}}>
        <Flex flexDirection={{base: 'column', md: 'row'}}>
          <Flex w={{base: '100%', md: '70%'}} flexDirection={'column'}>
            <Text sx={styles.title}>{'Câu trả lời của bạn'}</Text>
            {message.message?.score_display?.map((item: any, index: any) => {
              return (
                <Box key={index} w={'100%'}>
                  {index > 0 && (
                    <Center mb={'8px'} mt={'8px'}>
                      <Image src={IconArrow} />
                    </Center>
                  )}
                  <Flex sx={styles.textWrap}>
                    <Text sx={styles.textItem}>{item?.user_answer}</Text>
                  </Flex>
                </Box>
              )
            })}
          </Flex>
          <Flex
            className="brand-score-container"
            w={{base: '100%', md: '30%'}}
            flexDirection={'column'}
            ml={{base: 0, md: 16}}
            mt={{base: 4, md: 0}}>
            <Flex flexDirection={'row'} flex={1}>
              <Text sx={styles.title}>{'Band điểm IELTS dự đoán'}</Text>
              <Tooltip
                padding={'6px'}
                maxW={'410px'}
                textAlign={'center'}
                color={'#FFFFFF'}
                bg={'#595959'}
                label={
                  <Flex flexDirection={'column'}>
                    <Text color={'#ffffff'} fontWeight={400} fontSize={'16px'}>
                      Phần điểm mang tính chất tham khảo.{' '}
                    </Text>
                    <Text color={'#ffffff'} fontWeight={400} fontSize={'16px'}>
                      Để biết điểm chính xác hơn, hãy sử dụng phần Thi thử.{' '}
                    </Text>
                  </Flex>
                }
                placement="top"
                openDelay={200}>
                <Image
                  marginLeft={'2px'}
                  height={'18px'}
                  width={'18px'}
                  src={IconDetail}
                />
              </Tooltip>
            </Flex>
            {message?.message?.score_display?.map((item: any, index: any) => {
              return (
                <Flex
                  key={index}
                  alignItems={'center'}
                  flexDirection={'column'}
                  alignSelf={'flex-start'}>
                  {index > 0 && (
                    <Box mb={'8px'} mt={'8px'}>
                      <Image src={IconArrow} />
                    </Box>
                  )}
                  <Center sx={styles.score}>
                    <Text sx={styles.textScore}>{item?.score}</Text>
                  </Center>
                </Flex>
              )
            })}
          </Flex>
        </Flex>
        {!isExpand ? (
          <Center>
            <Flex
              flexDirection={'row'}
              alignItems={'center'}
              m={2}
              onClick={() => onClickExpand()}>
              <Text cursor={'pointer'} sx={styles.textExpand}>
                {'Xem nhận xét chi tiết'}
              </Text>
              <Icon
                w={'24px'}
                h={'24px'}
                sx={{
                  stroke: '#292D32',
                }}>
                <ArrowDownIcon />
              </Icon>
            </Flex>
          </Center>
        ) : (
          <Box mb={2} mt={4}>
            <Grid
              templateRows={{base: 'repeat(4, 1fr)', md: 'repeat(2, 1fr)'}}
              templateColumns={{base: '1fr', md: 'repeat(2, 1fr)'}}
              gap={4}>
              <GridItem w="100%">
                <Flex flexDirection={'column'} sx={styles.expandItem}>
                  <Text sx={styles.title}>{'Fluency and Coherence'}</Text>
                  <Text sx={styles.textContent} whiteSpace="pre-line">
                    {dataExpand?.fluency}
                  </Text>
                </Flex>
              </GridItem>
              <GridItem w="100%">
                <Flex flexDirection={'column'} sx={styles.expandItem}>
                  <Text sx={styles.title}>{'Vocabulary'}</Text>
                  <Text sx={styles.textContent} whiteSpace="pre-line">
                    {dataExpand?.vocabulary}
                  </Text>
                </Flex>
              </GridItem>
              <GridItem w="100%">
                <Flex flexDirection={'column'} sx={styles.expandItem}>
                  <Text sx={styles.title}>{'Grammar'}</Text>
                  <Text sx={styles.textContent} whiteSpace="pre-line">
                    {dataExpand?.grammar}
                  </Text>
                </Flex>
              </GridItem>
              <GridItem w="100%">
                <Flex flexDirection={'column'} sx={styles.expandItem}>
                  <Text sx={styles.title}>{'Pronunciation'}</Text>
                  <Text sx={styles.textContent} whiteSpace="pre-line">
                    {dataExpand?.pronunciation}
                  </Text>
                </Flex>
              </GridItem>
            </Grid>
          </Box>
        )}
      </Box>
    </div>
  )
}

const styles = {
  container: {
    borderColor: CommonColors.blue,
    backgroundColor: CommonColors.white,
    borderRadius: '32px',
    borderWidth: 1,
    minWidth: {base: '85%', md: '80%'},
  },
  item: {
    minWidth: '300px',
  },
  textWrap: {
    backgroundColor: CommonColors.blue,
    padding: {base: '12px', md: '16px'},
    borderRadius: '32px',
    minHeight: {base: '60px', md: '80px'},
    alignItems: 'center',
  },
  title: {
    fontWeight: 700,
    fontSize: {base: '14px', md: '16px'},
    marginBottom: {base: '12px', md: '16px'},
  },
  textScore: {
    fontWeight: 700,
    fontSize: {base: 32, md: 40},
  },
  textItem: {
    fontWeight: 500,
    fontSize: {base: '14px', md: '16px'},
    color: CommonColors.white,
  },
  score: {
    padding: '16px',
    width: {base: '60px', md: '80px'},
    height: {base: '60px', md: '80px'},
    borderRadius: {base: '30px', md: '40px'},
    backgroundColor: 'rgba(1, 172, 255, 0.1)',
  },
  expandItem: {
    padding: '16px',
    backgroundColor: CommonColors.blue1,
    borderRadius: '12px',
  },
  textContent: {
    fontWeight: 500,
    fontSize: 14,
    color: CommonColors.shadow,
  },
  textExpand: {
    fontWeight: 700,
    fontSize: 14,
    color: CommonColors.shadow1,
  },
}

export default BrandScore
